/**
 * Browser-test environment for the legacy desenvolvimento services.
 *
 * The per-city rest-/tiles- hosts from the old configuration currently resolve
 * to an Airflow certificate, so the generic desenvolvimento PostgREST/tiles
 * hosts are used here. Tenant headers still scope requests to the city.
 */
const developmentPlatformUrl =
  'https://plataforma.desenvolvimento.geo360.topocart.dev.br/';
const developmentPostgrestUrl =
  'https://rest.plataforma.desenvolvimento.geo360.topocart.dev.br';
const developmentTilesUrl =
  'https://tiles.plataforma.desenvolvimento.geo360.topocart.dev.br/';

export const environment = {
  municipio: '',
  production: false,
  isDesenvolvimento: true,
  isETopocartDev: false,
  isETopocartProd: false,
  isTopocart: false,
  isTopocartDev: true,
  isPortoVelho: false,
  isAlexania: false,
  isManaus: false,

  googleMapsKey: 'AIzaSyDa_RGUAd9-34P9bgA4181u_TPurVM-5FE',
  googleMapsAPI: 'https://maps.googleapis.com/maps/api/',
  captchaKey: '6Lea54kpAAAAANda_edNp3kvEmUqrLIvwWHLzdwj',
  googleGeoCodeAPI: 'https://maps.googleapis.com/maps/api/geocode/json',

  reportsUrl: 'https://relatorios.desenvolvimento.geo360.topocart.dev.br/',
  reportUrl: 'https://relatorios.desenvolvimento.geo360.topocart.dev.br/',
  reportV2Url: 'https://relatorios-v2.desenvolvimento.geo360.topocart.dev.br/',

  visualizador360BaseUrl:
    'https://visualizador360.desenvolvimento.geo360.topocart.dev.br',
  apiUrl: developmentPlatformUrl,
  conversorUrl: 'https://conversor.desenvolvimento.geo360.topocart.dev.br/',
  apiDjangoUrl: `${developmentPlatformUrl}django/`,

  // Generic endpoints are used instead of the legacy per-city hosts because
  // they are browser-safe and accept the tenant headers returned by /ouv/.
  apiUrlPostgrest: developmentPostgrestUrl,
  apiUrlGenericPostgrest: developmentPostgrestUrl,
  apiUrlGenericPGTiles: developmentTilesUrl,
  apiUrlPGTiles: developmentTilesUrl,
  postgRestUrl: developmentPostgrestUrl,
  pgtilesUrl: developmentTilesUrl,

  apiDjangoDirectUrl:
    'https://cadastro.desenvolvimento.geo360.topocart.dev.br/',
  djangoDirectUrlToken: 'Bearer edd8ceaa-343b-41ef-b5ef-6f03a5122d2b',
  apiAttributesTable:
    'https://tabela-atributos.desenvolvimento.geo360.topocart.dev.br/',
  caracterizacaoUrl:
    'https://caracterizacao.desenvolvimento.geo360.topocart.dev.br',

  openRestUrl: 'https://openrest.desenvolvimento.geo360.topocart.dev.br/',

  // The legacy generic PostgREST service is the gateway for RPC calls too.
  apiGatewayUrl: `${developmentPostgrestUrl}/`,
  apiGatewayRestPrefix: '',

  apiCNAE: 'https://cnae.criciuma.apps.etopocart.com/',
  geoServerUrl: 'https://mapsrv2.webgeo.io/geoserver/',
  geoServerWFSUrl: 'https://mapsrv2.webgeo.io/geoserver/wfs',
  photonApi: 'https://photon.komoot.de/api/',

  firebase: {
    apiKey: 'AIzaSyD4riPTBVU39qL336AjXfdroCJwNUwQvg',
    authDomain: 'webgeo-test.firebaseapp.com',
    databaseURL: 'https://webgeo-test.firebaseio.com',
    projectId: 'webgeo-test',
    storageBucket: 'webgeo-test.appspot.com',
    messagingSenderId: '358703366933',
    appId: '1:358703366933:web:27b8be17ee90f30ba35f1c',
  },
  recaptchaKey: '6LcvkeAUAAAAAHy5Kofj78q5mntZFwHwL98KBFGI',
  mapboxToken:
    'pk.eyJ1Ijoidm0ybWFwYm94IiwiYSI6ImNrbTF6MTYzczB6aGYybnIzcDY0eW9vb2sifQ.J9ErWF5EO5w3oLqGjzqi_w',
};
